var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.32223C0 1.25861 0 0.726804 0.21394 0.43365C0.400319 0.178261 0.685192 0.0202233 0.993573 0.00113689C1.34755 -0.0207719 1.77443 0.274223 2.62818 0.864213L13.7383 8.54198C14.4438 9.02948 14.7965 9.27323 14.9194 9.58046C15.0269 9.84906 15.0269 10.1509 14.9194 10.4195C14.7965 10.7268 14.4438 10.9705 13.7383 11.458L2.62817 19.1358C1.77443 19.7258 1.34755 20.0208 0.993573 19.9989C0.685192 19.9798 0.400319 19.8217 0.21394 19.5663C0 19.2732 0 18.7414 0 17.6778V2.32223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.189601dc19200bd4e13f1bfd579756f2.svg";
export { ForwardRef as ReactComponent };